/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Accessibility
  window.args = {
    sitekey: "a4e2b1076d509588321ded95bde20049",
    position: "left",
    language: "HE",
    container: "",
    icon: "",
    access: "https://vee-crm.com",
    links: {
      acc_policy:
        "https://redefine-hair.com/pages/%D7%94%D7%A6%D7%94%D7%A8%D7%AA-%D7%A0%D7%92%D7%99%D7%A9%D7%95%D7%AA",
      additional_link: "https://vee.co.il/pricing/",
    },
  };

  (function (doc, head, body) {
    var embed = doc.createElement("script");
    embed.src = window.args["access"] + "/js/";
    embed.defer = true;
    embed.crossOrigin = "anonymous";
    embed.setAttribute("data-cfasync", true);
    body ? body.appendChild(embed) : head.appendChild(embed);
  })(document, document.head, document.body);
})();
